import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import HeaderPortal from '../../../../components/layout/HeaderPortal';
import Portal from 'utils/portal/Portal';
import { withAreaGetter } from 'providers/AreasConsumers';
import { ADMIN_USER_GROUPS_READ, ADMIN_USER_GROUPS_WRITE } from 'constants/rightsCodes';
import UsersListBrowser from './UsersListBrowser';
import { areas } from 'constants/areas';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = ({ getElemByAreaKey }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_USER_GROUPS_WRITE} withForbiddenPage={false}>
          <IconButton
            onClick={() => historyContext.push('/users/new')}
            type='add'
            fontSize='medium'
            color='transparent'
            tooltip={t('Users.Add')}
          />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_USER_GROUPS_READ}>
        <UsersListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
